var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHrWidgetsGroup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8 3H4.2C3.12304 3 2.25 4.15127 2.25 5.57143V18.4286C2.25 19.8487 3.12304 21 4.2 21H19.8C20.877 21 21.75 19.8487 21.75 18.4286V5.57143C21.75 4.15127 20.877 3 19.8 3Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.25 7.25C7.69772 7.25 7.25 7.69772 7.25 8.25C7.25 8.80228 7.69772 9.25 8.25 9.25H18.75C19.3023 9.25 19.75 8.80228 19.75 8.25C19.75 7.69772 19.3023 7.25 18.75 7.25H8.25ZM5.25 9C5.66421 9 6 8.66421 6 8.25C6 7.83579 5.66421 7.5 5.25 7.5C4.83579 7.5 4.5 7.83579 4.5 8.25C4.5 8.66421 4.83579 9 5.25 9Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.25 11C7.69772 11 7.25 11.4477 7.25 12C7.25 12.5523 7.69772 13 8.25 13H18.75C19.3023 13 19.75 12.5523 19.75 12C19.75 11.4477 19.3023 11 18.75 11H8.25ZM5.25 12.75C5.66421 12.75 6 12.4142 6 12C6 11.5858 5.66421 11.25 5.25 11.25C4.83579 11.25 4.5 11.5858 4.5 12C4.5 12.4142 4.83579 12.75 5.25 12.75Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.25 14.75C7.69772 14.75 7.25 15.1977 7.25 15.75C7.25 16.3023 7.69772 16.75 8.25 16.75H18.75C19.3023 16.75 19.75 16.3023 19.75 15.75C19.75 15.1977 19.3023 14.75 18.75 14.75H8.25ZM5.25 16.5C5.66421 16.5 6 16.1642 6 15.75C6 15.3358 5.66421 15 5.25 15C4.83579 15 4.5 15.3358 4.5 15.75C4.5 16.1642 4.83579 16.5 5.25 16.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHrWidgetsGroup);
export default __webpack_public_path__ + "static/media/HRWidgets-group.2fbe3a6f2559e71f74ed2b37d23bb77d.svg";
export { ForwardRef as ReactComponent };